export default __webpack_public_path__ + "static/media/GR00051-color_spot_2.46ce3b73.svg";